import { createSelector } from 'reselect';
import { formatDate } from 'core/utils/apis/responseParsers/commonParsers/formatDateParser';
import { selectMerchantFeaturedBonusOffer } from 'core/modules/BonusOffers/selectors';

const formatOfferDate = offer => ({
  ...offer,
  expires: formatDate(offer.expires, 'MMM DD, YYYY'),
});

const addAndDedupeBonusOffer = (offers, bonusOffer) => (
  bonusOffer ?
    [
      bonusOffer,
      ...offers.filter(offer => (
        !(bonusOffer.description.toLowerCase() === offer.description.toLowerCase() && bonusOffer.code === offer.code)
      )),
    ] : offers);

export const selectMerchantExperience = state => state.merchantExperience;

export const selectMerchantExperienceConfig = createSelector(
  selectMerchantExperience,
  merchantExperience => merchantExperience.config,
);

export const selectMerchantExperienceMerchants = createSelector(
  [selectMerchantExperience, selectMerchantFeaturedBonusOffer],
  (merchantExperience, featuredOffer) => {
    const { merchants } = merchantExperience;
    if (merchants && merchants[0] && merchants[0].offers) {
      return merchants.map((merchant) => {
        const formatedOffers = merchant.offers.map(offer => formatOfferDate(offer));

        return {
          ...merchant,
          offers: addAndDedupeBonusOffer(formatedOffers, featuredOffer),
        };
      });
    }
    return merchants;
  },
);

export const selectMerchantExperienceIsLoading = createSelector(
  selectMerchantExperience,
  merchantExperience => merchantExperience.isLoading,
);

export const selectMerchantExperienceIsLoaded = createSelector(
  selectMerchantExperience,
  merchantExperience => merchantExperience.isLoaded,
);
